'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Heading, Picture, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import Link from 'next/link';
import { ContentfulClick } from '@libs/analytics';
import { NEW_TAB, PRIMARY_BUTTON_STYLE, SECONDARY_BUTTON_STYLE, TARGET_BLANK, TARGET_SELF } from '../../constants';
import { propsImageItems } from '../../utils/propsImagesItems';
import type { CampaignHeroVariantProps } from './types';
import './CampaignHeroFullWidth.scss';
export default function CampaignHeroFullWidth(t0) {
  const $ = _c(41);
  const {
    header,
    preheader,
    body,
    primaryTextColor,
    image,
    cta,
    internalTitle,
    isH1
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = propsImageItems(image, true);
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageItems = t1;
  const Container = cta ? Link : "div";
  const t2 = primaryTextColor === "Dark Grey";
  const t3 = primaryTextColor === "Dark Grey w/ Red";
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = cn("campaign-hero-fwidth", {
      "campaign-hero-fwidth__grey": t2,
      "campaign-hero-fwidth__red": t3
    });
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = cta?.behavior === NEW_TAB ? TARGET_BLANK : TARGET_SELF;
  const t6 = cta?.link.webUrl ?? "";
  const t7 = cta?.text;
  let t8;
  if ($[5] !== body || $[6] !== header || $[7] !== preheader || $[8] !== t7) {
    t8 = cn(preheader, header, body, t7);
    $[5] = body;
    $[6] = header;
    $[7] = preheader;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = cta?.link.webUrl ?? "";
  let t10;
  if ($[10] !== header || $[11] !== internalTitle || $[12] !== t8 || $[13] !== t9) {
    t10 = {
      linkText: t8,
      linkUrl: t9,
      promoTitle: header,
      promoVariant: "campaign hero - full-width",
      promoDesc: internalTitle,
      promoType: "campaign-hero-fwidth"
    };
    $[10] = header;
    $[11] = internalTitle;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = imageItems[0]?.srcSet;
  let t12;
  if ($[15] !== image.webAltText || $[16] !== imageItems || $[17] !== t11) {
    t12 = <Picture imgAlt={image.webAltText} imgSrc={t11} items={imageItems} />;
    $[15] = image.webAltText;
    $[16] = imageItems;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== preheader) {
    t13 = preheader && <TextPassage className="campaign-hero-fwidth__preheader">{preheader}</TextPassage>;
    $[19] = preheader;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = isH1 ? "h1" : "h2";
  let t15;
  if ($[21] !== header || $[22] !== t14) {
    t15 = <Heading tagName={t14} className="campaign-hero-fwidth__heading">{header}</Heading>;
    $[21] = header;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== body) {
    t16 = body && <TextPassage className="campaign-hero-fwidth__text">{body}</TextPassage>;
    $[24] = body;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== cta) {
    t17 = cta && <Button variant={cta.buttonStyle.toLowerCase() === "primary" ? PRIMARY_BUTTON_STYLE : SECONDARY_BUTTON_STYLE} text={cta.text} size="lg" />;
    $[26] = cta;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t13 || $[29] !== t15 || $[30] !== t16 || $[31] !== t17) {
    t18 = <div className="campaign-hero-fwidth__body">{t13}{t15}{t16}{t17}</div>;
    $[28] = t13;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== Container || $[34] !== t10 || $[35] !== t12 || $[36] !== t18 || $[37] !== t4 || $[38] !== t5 || $[39] !== t6) {
    t19 = <ContentfulClick component={Container} className={t4} target={t5} href={t6} prefetch={false} eventData={t10}>{t12}{t18}</ContentfulClick>;
    $[33] = Container;
    $[34] = t10;
    $[35] = t12;
    $[36] = t18;
    $[37] = t4;
    $[38] = t5;
    $[39] = t6;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  return t19;
}